import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { SpinoffAuthService } from './spinoff-auth.service';

export const spinoffAuthGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(SpinoffAuthService);
  const router = inject(Router);

  if (!auth.ready()) {
    await auth.init();
  }

  if (auth.isAuthenticated()) return true;

  return router.createUrlTree([auth.loginPath], {
    queryParams: { return: state.url },
  });
};
